import { render, staticRenderFns } from "./VendorAT.vue?vue&type=template&id=ba123b98&scoped=true&"
import script from "./VendorAT.vue?vue&type=script&lang=js&"
export * from "./VendorAT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba123b98",
  null
  
)

export default component.exports